export const productsRangeToExport = {
  min: 30,
  max: 1000,
};
